import { render, staticRenderFns } from "./uploadDocument.vue?vue&type=template&id=3545e960&scoped=true"
import script from "./uploadDocument.vue?vue&type=script&lang=js"
export * from "./uploadDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3545e960",
  null
  
)

export default component.exports